import InputGroupContent from '@/components/elements/input'
import Select from '@/components/elements/select'
import { Box, Flex, Heading } from '@chakra-ui/react'
import Submit from '@/components/elements/submit'
import { categoryOptions } from '@/utils/maps/categories-maps'
import { useForm } from 'react-hook-form'
import { AppDispatch, RootState } from '@/store/store'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { categoriesSchema } from '@/entities/schemas/categories'
import Toast from '@/components/elements/toast'
import { updateCategoryFn } from '@/store/features/categories'
import { updateCategoryById } from '@/services/api/categories/categories'
import SpinnerLoading from '@/components/elements/spinner'
import { categoryRefrestUpdate, sessionRefrestUpdate } from '@/store/features/state'
import CategoriesEntity from '@/entities/api/categories/categories'
import { useFormErrorToast } from '@/hooks/useFormErrorToast'

const EditCategory = ({
	category,
	close,
}: {
	category: CategoriesEntity
	close: () => void
}) => {
	const token = useSelector((state: RootState) => state.auth.token)
	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm<CategoriesEntity>({
		resolver: yupResolver(categoriesSchema),
	})
	useFormErrorToast(errors)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const dispatch = useDispatch<AppDispatch>()

	const onSubmit = async (categoryData: CategoriesEntity) => {
		try {
			setIsLoading(true)

			const response = await updateCategoryById(
				token ?? '',
				category?._id ?? '',
				{
					type: categoryData?.type ? categoryData?.type : category?.type,
					name: categoryData?.name ? categoryData?.name : category?.name,
				}
			)

			if (response?.status === 500 || response?.status === 404) {
				Toast({
					type: 'error',
					message: 'Hubo un error y no se puede actualizar la categoria',
				})
				return
			}

			if (response?.status === 401) {
				dispatch(sessionRefrestUpdate())
				return
			}

			Toast({ type: 'success', message: 'Categoria actualizada con exito' })
			dispatch(dispatch(updateCategoryFn({ ...category, ...categoryData })))
			dispatch(categoryRefrestUpdate())
			setIsLoading(false)
			close()
		} catch (error) {
			Toast({
				type: 'error',
				message: 'Hubo un error y no se puede actualizar la categoria',
			})
			setIsLoading(false)
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Flex w='100%' h='full' flexDirection='column' alignItems='center'>
				<Box
					w='full'
					display='flex'
					justifyContent='start'
					alignItems='center'
					mb='2'
				>
					<Heading
						as='h4'
						fontSize={{ base: 'lg', md: 'xl' }}
						color='black'
						fontWeight='900'
					>
						Informacion general
					</Heading>
				</Box>
				<InputGroupContent
					label='Nombre de la categoría'
					placeholder='Ingresa el nombre de la categoría'
					name='name'
					defaultValue={category?.name ?? ''}
					type='text'
					register={register}
					errors={errors}
				/>
				<Select
					name='type'
					label='Categoría padre'
					placeholder='Selecciona una categoría padre'
					options={categoryOptions}
					control={control}
					isRequired={true}
					defaultValue={category?.type ?? ''}
				/>
				<Box pt='4' pb='8'>
					{isLoading ? <SpinnerLoading /> : <Submit text='Editar categoria' />}
				</Box>
			</Flex>
		</form>
	)
}

export default EditCategory
